import { Tag } from '@datahub/design-system'

/**
 * Cycle status colours (plan Section 12.7). The system has no amber, so
 * "due soon" is expressed in text rather than colour.
 */
const STATUS: Record<string, { label: string; swatch: string }> = {
  scheduled: { label: 'Scheduled', swatch: '#9CA3AF' },
  open: { label: 'Open', swatch: '#85BEFF' },
  overdue: { label: 'Overdue', swatch: '#F05042' },
  submitted: { label: 'Submitted', swatch: '#22C55E' },
  amended: { label: 'Amended', swatch: '#22C55E' },
  closed: { label: 'Closed', swatch: '#4B5563' },
  draft: { label: 'Draft', swatch: '#9CA3AF' },
  active: { label: 'Active', swatch: '#22C55E' },
  paused: { label: 'Paused', swatch: '#9CA3AF' },
  archived: { label: 'Archived', swatch: '#4B5563' },
  invited: { label: 'Invited', swatch: '#85BEFF' },
  deactivated: { label: 'Deactivated', swatch: '#4B5563' },
  bounced: { label: 'Bounced', swatch: '#F05042' },
  unsubscribed: { label: 'Unsubscribed', swatch: '#4B5563' },
  pending: { label: 'Pending', swatch: '#9CA3AF' },
  delivered: { label: 'Delivered', swatch: '#22C55E' },
  failed: { label: 'Failed', swatch: '#F05042' },
  clean: { label: 'Scanned', swatch: '#22C55E' },
  infected: { label: 'Infected', swatch: '#F05042' },
  not_started: { label: 'Not started', swatch: '#9CA3AF' },
  partial: { label: 'Partly copied', swatch: '#85BEFF' },
  done: { label: 'Copied to Core', swatch: '#22C55E' },
  confidential: { label: 'Confidential', swatch: '#F05042' },
}

export function StatusTag({ status, suffix }: { status: string; suffix?: string }) {
  const entry = STATUS[status] ?? { label: status, swatch: '#9CA3AF' }
  return <Tag swatch={entry.swatch}>{suffix ? `${entry.label} · ${suffix}` : entry.label}</Tag>
}
